'use client'

import { type ReactNode, useEffect, useMemo } from 'react'
import { useSetPageTitle } from '@/contexts/page-title-context'
import { PAGE_TITLE_CLASSES } from '@/lib/shared/layout-constants'

export interface PlatformHeaderProps {
  /** The section's name, such as Automations. */
  title: string
  /** Section-level actions rendered before the global header actions. */
  children?: ReactNode
}

/**
 * App-header title for a top-level section page: its name and optional
 * actions. A page nested under a section uses `DetailPageHeader`, which owns
 * the `Parent / Child` breadcrumb.
 */
export function PlatformHeader({
  title,
  children = null,
}: PlatformHeaderProps) {
  const setPageTitle = useSetPageTitle()

  const titleContent = useMemo(
    () => <h1 className={PAGE_TITLE_CLASSES}>{title}</h1>,
    [title]
  )

  useEffect(() => {
    setPageTitle({ titleContent, rightContent: children })
    return () => setPageTitle({ titleContent: null, rightContent: null })
  }, [setPageTitle, titleContent, children])

  return null
}
